// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skill-title {
	text-align: left;
	font-size: 20px !important;
	height: 26px;
	font-weight: 500 !important;
	letter-spacing: 0;
	margin-top: 48px;
	margin-bottom: 0;
	color: #444444;
	opacity: 1;
}

.section-body {
	margin-top: 24px;
}

.section-part {
	margin-bottom: 35px;
}

.part-header .part-title {
	font-weight: 500;
	color: #444;
	margin-bottom: 20px;
}

.part-title.title-error {
	color: #F86567 !important;
}

.part-header {
	margin-bottom: 24px;
}

.part-description {
	display: block;
}

.alert-text {
	color: #f86567;
	display: block;
}

.skill-list {
	width: 100%;
	table-layout: fixed;
}

.skill-list tr th,td {
	border: 0;
	padding: 10px 7px 10px 10px;
}

.skill-info {
	width: 30%;
	border-bottom: solid 1px #c6c6c6 !important;
}

.skill-list.expand-width .skill-info {
	width: 40%
}

.spin-container {
	display: inline-block;
	width: 10px;
	position: relative;
	height: 18px;
	margin-top: -10px;
	margin-left: 10px;
}

.arrow-up{
	display: block;
    position: absolute;
    left: -7px;
    top: -3px;
}

.arrow-down {
	display: block;
    position: absolute;
    left: -7px;
    top: 3px;
}


.badge {
	min-width: 80px !important;
	padding: 5px !important;
	margin-bottom: 0 !important;
	margin-right: 5px;
}

.skill-tag-row {
	padding-left: 2px;
	display: inline-block;
}

.skill-tag-message-mobile {
	display: none;
}

@media only screen and (max-width: 576px) {

	.skill-tag-message-mobile {
		display: inline-block;
		font-size: 2vw !important;
		min-width: 40px !important;
	}

	.skill-tag-message {
		display: none;
	}

}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/SkillEditor/SkillEditor.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B,YAAY;CACZ,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,2CAA2C;AAC5C;;AAEA;CACC;AACD;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;CACC,cAAc;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;;AAGA;CACC,0BAA0B;CAC1B,uBAAuB;CACvB,2BAA2B;CAC3B,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC;EACC,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;CAC3B;;CAEA;EACC,aAAa;CACd;;AAED","sourcesContent":[".skill-title {\n\ttext-align: left;\n\tfont-size: 20px !important;\n\theight: 26px;\n\tfont-weight: 500 !important;\n\tletter-spacing: 0;\n\tmargin-top: 48px;\n\tmargin-bottom: 0;\n\tcolor: #444444;\n\topacity: 1;\n}\n\n.section-body {\n\tmargin-top: 24px;\n}\n\n.section-part {\n\tmargin-bottom: 35px;\n}\n\n.part-header .part-title {\n\tfont-weight: 500;\n\tcolor: #444;\n\tmargin-bottom: 20px;\n}\n\n.part-title.title-error {\n\tcolor: #F86567 !important;\n}\n\n.part-header {\n\tmargin-bottom: 24px;\n}\n\n.part-description {\n\tdisplay: block;\n}\n\n.alert-text {\n\tcolor: #f86567;\n\tdisplay: block;\n}\n\n.skill-list {\n\twidth: 100%;\n\ttable-layout: fixed;\n}\n\n.skill-list tr th,td {\n\tborder: 0;\n\tpadding: 10px 7px 10px 10px;\n}\n\n.skill-info {\n\twidth: 30%;\n\tborder-bottom: solid 1px #c6c6c6 !important;\n}\n\n.skill-list.expand-width .skill-info {\n\twidth: 40%\n}\n\n.spin-container {\n\tdisplay: inline-block;\n\twidth: 10px;\n\tposition: relative;\n\theight: 18px;\n\tmargin-top: -10px;\n\tmargin-left: 10px;\n}\n\n.arrow-up{\n\tdisplay: block;\n    position: absolute;\n    left: -7px;\n    top: -3px;\n}\n\n.arrow-down {\n\tdisplay: block;\n    position: absolute;\n    left: -7px;\n    top: 3px;\n}\n\n\n.badge {\n\tmin-width: 80px !important;\n\tpadding: 5px !important;\n\tmargin-bottom: 0 !important;\n\tmargin-right: 5px;\n}\n\n.skill-tag-row {\n\tpadding-left: 2px;\n\tdisplay: inline-block;\n}\n\n.skill-tag-message-mobile {\n\tdisplay: none;\n}\n\n@media only screen and (max-width: 576px) {\n\n\t.skill-tag-message-mobile {\n\t\tdisplay: inline-block;\n\t\tfont-size: 2vw !important;\n\t\tmin-width: 40px !important;\n\t}\n\n\t.skill-tag-message {\n\t\tdisplay: none;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
